module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/arrow-down-81effd07f3ed9b602819c7c7dffaedaa.svg";